import agencyApi from 'api/agencyApi';
import agencyCommissionApi from 'api/agencyCommissionApi';
import AgencyHelper from 'features/Agency/agencyHelper';
import AgencyContractListView from 'features/Agency/components/AgencyContractListView';
import AgencySaleOrderListView from 'features/Agency/components/AgencySaleOrderListView';
import SubAgencyView from 'features/ManageDealer/components/SubAgencyView';
import TransactionHistoryView from 'features/ManageDealer/components/TransactionHistoryView';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import { AnimatePresence, motion } from 'framer-motion';
import AppTabs from 'general/components/AppTabs';
import BreadcrumbHelper from 'general/components/CustomBreadcrumb/BreadcrumbHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import CustomCard from 'general/components/Others/CustomCard';
import { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import useScrollToTop from 'hooks/useScrollToTop';
import moment from 'moment';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import RemainingAgenciesView from 'features/ManageDealer/components/RemainingAgenciesView';
import AppRoute from 'general/constants/AppRoute';
import KTScrollCard from 'general/components/OtherKeenComponents/KTScrollCard';
import ChargeHelper from 'features/Charge/chargeHelper';
import BankAccountsView from 'features/ManageDealer/components/BankAccountsView';
import agencyBankHelper from 'general/helpers/agencyBankHelper';
import AgencyUIHelper from 'general/helpers/AgencyUIHelper';
import BuildInfoCardView from 'features/ManageDealer/components/BuildInfoCardView';
import SaleKPIListView from 'features/ManageDealer/components/SaleKPIListView';
import UIHelper from 'general/helpers/UIHelper';

DealerDetailScreen.propTypes = {};

function DealerDetailScreen(props) {
  // ---- params ----
  const { isSaleInfo = false } = props;
  const { t } = useTranslation();
  const router = useRouter();
  const agencyInfoRef = useRef();
  const agencyId = router.query?.agencyId;
  const { user, permissionList } = useSelector((state) => state.auth);
  const [agencyDetail, setAgencyDetail] = useState();
  const [commission, setCommission] = useState();
  const [salesEnergyCommission, setSalesEnergyCommission] = useState();
  const [isAdminRole, setAdminRole] = useState(false);
  const [isAddContractDone, setAddContractDone] = useState(false);
  const agencyBank = agencyDetail?.bankAccounts?.length ? agencyDetail?.bankAccounts[0] : {};
  const isAgencyIndividual = useMemo(() => {
    return agencyDetail && agencyDetail?.type === AppConstants.accountType.individual;
  }, [agencyDetail]);
  const isAdminAgency = useMemo(() => {
    if (agencyDetail) {
      return !agencyDetail?.parentAgencyId
    }
    return false;
  }, [agencyDetail])
  const [isReady, setIsReady] = useState(false);
  const [parentAgencyDetail, setParentAgencyDetail] = useState();
  useEffect(() => {
    if (agencyDetail?.parentAgencyId) {
      AgencyHelper.API.requestAgencyDetail(agencyDetail?.parentAgencyId).then((data) => {
        setParentAgencyDetail(data);
      });
    }
  }, [agencyDetail]);

  useEffect(() => {
    if (
      user?.role === AppConstants.userRole.admin ||
      user?.role === AppConstants.userRole.operator
    ) {
      setAdminRole(true);
    }
  }, [user]);

  const [filterSubAgency, setFilterSubAgency] = useState({
    parentAgencyId: agencyId,
    role: 'SALE',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    operatorId: '',
    status: '',
    type: '',
    from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
    selectedValue: dateFilter.tatCaThoiGian,
    areaId: '',
    q: '',
    createdBy: '',
    deepLevel: '',
    hasSignedContract: '',
  });
  const [subAgencyTotal, setSubAgencyTotal] = useState(0);
  const [subAgenciesList, setSubAgenciesList] = useState([]);

  const [filterTransaction, setFilterTransaction] = useState({
    agencyId: agencyId,
    q: '',
    from: '',
    to: '',
    status: '',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    forRole: '',
    type: '',
    dateFilter: dateFilter.baMuoiNgayGanNhat,
  });
  const [transactionTotal, setTransactionTotal] = useState(0);
  const [transactionList, setTransactionList] = useState([]);

  const [filterRemainingAgencies, setFilterRemainingAgencies] = useState({
    parentAgencyId: agencyId,
    role: 'INVESTOR, GROUP, LANDLORD, COINVESTOR',
    q: '',
    status: '',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    type: '',
  });
  const [remainingAgenciesTotal, setRemainingAgenciesTotal] = useState(0);
  const [remainingAgenciesList, setRemainingAgenciesList] = useState([]);

  const [filterSaleKPI, setFilterSaleKPI] = useState({
    agencyId: agencyId,
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    month: '',
  });
  const [saleKPITotal, setSaleKPITotal] = useState(0);
  const [saleKPIList, setSaleKPIList] = useState([]);

  const [agencyBankList, setAgencyBankList] = useState([]);

  const [commissionUnit, setCommissionUnit] = useState('');

  useEffect(() => {
    handleSetCommissionUnit(commission?.energyCommissionMode);
  }, [commission]);

  const handleSetCommissionUnit = (value) => {
    if (DealerHelper.checkPercentCommissionMode(value)) {
      setCommissionUnit('%');
    } else {
      setCommissionUnit('VNĐ/kWh');
    }
  };

  const [isEnergyCommissionOn, setIsEnergyCommissionOn] = useState(true);
  const [isLandlordCommissionOn, setIsLandlordCommissionOn] = useState(true);

  useEffect(() => {
    if (
      commission?.length ||
      (typeof commission === 'object' && Object.values(commission)?.length)
    ) {
      const hasValidLandlordCommission = Array.isArray(commission?.landlordCommission) &&
        commission.landlordCommission.some(item => item != null);

      setIsLandlordCommissionOn(hasValidLandlordCommission);
    }
  }, [commission]);

  useEffect(() => {
    if (
      salesEnergyCommission?.length ||
      (typeof salesEnergyCommission === 'object' && Object.values(salesEnergyCommission)?.length)
    ) {
      if (salesEnergyCommission?.energyCommissionValue || salesEnergyCommission?.energyCommissionDuration) {
        setIsEnergyCommissionOn(true);
      } else setIsEnergyCommissionOn(false);

    } else setIsEnergyCommissionOn(false);
  }, [salesEnergyCommission]);

  useEffect(() => {
    if (commission) {
      if (!!commission?.landlordCommission?.length && commission?.landlordCommission?.some(item => item !== null)) {
        setIsLandlordCommissionOn(true);
      } else {
        setIsLandlordCommissionOn(false);
      }
    } else {
      setIsLandlordCommissionOn(true);
    }
  }, [commission]);

  const areaTree = useSelector((state) => state.app.areaTree);
  const [agencyArea, setAgencyArea] = useState(null);
  const [agencyParentArea, setAgencyParentArea] = useState(null);
  useEffect(() => {
    if (areaTree && !_.isEmpty(areaTree) && agencyDetail) {
      const agencyAreaId = agencyDetail?.areaId;
      const agencyArea = ChargeHelper.Utils.getAreaById([areaTree], agencyAreaId);
      if (agencyArea?.typeCode === 'W') {
        setAgencyArea(agencyArea);
        setAgencyParentArea(ChargeHelper.Utils.getAreaById([areaTree], agencyArea?.parentId));
      } else if (agencyArea?.typeCode === 'P') {
        setAgencyParentArea(agencyArea);
      }
    }
  }, [areaTree, agencyDetail]);

  useEffect(() => {
    handleGetSubAgenciesList();
  }, [filterSubAgency, agencyId]);

  const handleGetSubAgenciesList = async () => {
    try {
      const { total, agencies, revenue } = await agencyApi.getAgencyList(filterSubAgency);
      const updatedAgencies = DealerHelper.mergeRevenueIntoAgencies(agencies, revenue);
      setSubAgenciesList(updatedAgencies);
      setSubAgencyTotal(total);
    } catch (error) {
      console.error('Error fetching sub-agencies list:', error);
    }
  };

  useEffect(() => {
    handleGetRemainingAgenciesList();
  }, [filterRemainingAgencies, agencyId]);

  const handleGetRemainingAgenciesList = async () => {
    try {
      const { total, agencies } = await agencyApi.getAgencyList(filterRemainingAgencies);
      setRemainingAgenciesList(agencies);
      setRemainingAgenciesTotal(total);
    } catch (error) {
      console.error('Error fetching remaining agencies list:', error);
    }
  };

  useEffect(() => {
    if (isAdminRole) {
      handleGetTransactionList();
    }
  }, [filterTransaction, isAdminRole]);

  const handleGetTransactionList = async () => {
    const res = await agencyCommissionApi.getAgencyCommissionTransactions(filterTransaction);
    const { total, transactions } = res;
    setTransactionList(transactions);
    setTransactionTotal(total);
  };

  useEffect(() => {
    if (isAdminRole) {
      handleGetKPIList();
    }
  }, [filterSaleKPI, isAdminRole]);

  const handleGetKPIList = async () => {
    const res = await DealerHelper.callApiGetSaleKPIList(filterSaleKPI);
    const { total, saleKPIs } = res;
    setSaleKPIList(saleKPIs);
    setSaleKPITotal(total);
  };

  useEffect(() => {
    if (isAdminRole || isSaleInfo) {
      handleGetAgencyBankList();
    }
  }, [agencyId, isAdminRole, isSaleInfo]);

  const handleGetAgencyBankList = async () => {
    const res = await agencyBankHelper.callApiGetAgencyBankList({ agencyId: agencyId });
    setAgencyBankList(res);
  };

  const hash = router?.location?.hash;
  const [selectedTab, setSelectedTab] = useState('Danh sách hợp đồng');
  useEffect(() => {
    if (isAdminAgency) setSelectedTab('Lịch sử bán hàng');
  }, [isAdminAgency])
  const tabs = useMemo(() => {
    if (isAdminRole) {
      if (isAdminAgency) {
        return [
          t('Danh sách hợp đồng'),
          'Đại lý cấp dưới',
          'Lịch sử bán hàng',
          'Lịch sử giao dịch',
          'NĐT và chủ mặt bằng',
        ].reverse();
      } else {
        return [
          t('Danh sách hợp đồng'),
          'Đại lý cấp dưới',
          'Lịch sử bán hàng',
          'Lịch sử giao dịch',
          'NĐT và chủ mặt bằng',
          'Tài khoản ngân hàng',
          'Danh sách KPI',
        ].reverse();
      }
    } else if (isSaleInfo) {
      if (isAdminAgency) {
        return ['Lịch sử bán hàng'].reverse();
      } else {
        return [t('Danh sách hợp đồng'), 'Tài khoản ngân hàng', 'Danh sách KPI',].reverse();
      }
    } else {
      return [
        t('Danh sách hợp đồng'),
        'Đại lý cấp dưới',
        'Lịch sử bán hàng',
        'NĐT và chủ mặt bằng',
        'Danh sách KPI',
      ].reverse();
    }
  }, [t, isAdminRole, isAdminAgency, isSaleInfo]);

  useEffect(() => {
    if (hash === '#contract-list') setSelectedTab(t('Danh sách hợp đồng'));
    if (hash === '#sub-agencies') setSelectedTab('Đại lý cấp dưới');
    if (hash === '#order-history') setSelectedTab('Lịch sử bán hàng');
    if (hash === '#transaction-history') setSelectedTab('Lịch sử giao dịch');
    if (hash === '#remaining-agencies') setSelectedTab('NĐT và chủ mặt bằng');
    if (hash === '#bank-accounts') setSelectedTab('Tài khoản ngân hàng');
    if (hash === '#kpi-list') setSelectedTab('Danh sách KPI');
  }, [hash]);

  const [monthSaleKPI, setMonthSaleKPI] = useState({});
  const [monthCoinvestorKPI, setMonthCoinvestorKPI] = useState({});
  const [monthPackageKPI, setMonthPackageKPI] = useState({});
  const [monthChargePointKPI, setMonthChargePointKPI] = useState({});
  const currentMonth = moment().format('YYYY-MM');
  const getAgencyDetail = (id) => {
    DealerHelper.callApiGetAgencyDetail(id).then((data) => {
      if (Object.keys(data)?.length > 0) {
        setAgencyDetail(data);
        if (data?.commissions?.length > 0) {
          const commission = data?.commissions?.length > 0
            ? data.commissions.find((item) => item?.role === 'SALE' && !item?.stationId)
            : [];
          setCommission(commission);
          const salesEnergyCommission = data?.commissions?.length > 0
            ? data.commissions.find((item) => item?.role === 'SALE' && item?.stationId && item?.isInvestorEnergyCommission)
            : [];
          setSalesEnergyCommission(salesEnergyCommission);
          const coinvestorEnergyCommission = data?.commissions?.length > 0
            ? data.commissions.find((item) => item?.role === 'SALE' && item?.stationId && !item?.isInvestorEnergyCommission)
            : [];
          setCoinvestorEnergyCommission(coinvestorEnergyCommission);
        }
        setIsReady(true);
        const monthSaleKPI = data?.kpis?.find(kpi => kpi?.orderType === 'INVESTOR' && kpi?.month === currentMonth);
        setMonthSaleKPI(monthSaleKPI);
        const monthCoinvestorKPI = data?.kpis?.find(kpi => kpi?.orderType === 'COINVESTOR' && kpi?.month === currentMonth);
        setMonthCoinvestorKPI(monthCoinvestorKPI);
        const monthPackageKPI = data?.kpis?.find(kpi => kpi?.orderType === 'GROUP' && kpi?.month === currentMonth);
        setMonthPackageKPI(monthPackageKPI);
        const monthChargePointKPI = data?.kpis?.find(kpi => kpi?.orderType === 'CHARGEPOINT' && kpi?.month === currentMonth);
        setMonthChargePointKPI(monthChargePointKPI);
      } else {
        router.navigate(-1);
      }
    });
  };

  const [premiseList, setPremiseList] = useState([]);
  useEffect(() => {
    const params = {
      page: 0,
      limit: 5,
      agencyId: agencyId || '',
    };
    AgencyHelper.API.requestGetPremiseList(params)
      .then((response) => {
        setPremiseList(response?.premises);
      })
  }, [agencyDetail]);


  const handleGetLandlordCommissionType = (row) => {
    if (!row) return 'Không xác định';

    const hasFixedCommission = row?.sales[0]?.amount > 0;
    if (hasFixedCommission && row?.saleEnergyCommissionValue === 0 && row?.saleEnergyCommissionDuration === 0) {
      return 'Hoa hồng cố định';
    }
    if (!hasFixedCommission && row?.saleEnergyCommissionValue > 0 && row?.saleEnergyCommissionDuration > 0) {
      return 'Hoa hồng theo doanh thu điện';
    }
    if (hasFixedCommission && row?.saleEnergyCommissionValue > 0 && row?.saleEnergyCommissionDuration > 0) {
      return 'Hoa hồng kết hợp';
    }
    return 'Hoa hồng cố định';
  };

  const [selectedChargeStation, setSelectedChargeStation] = useState(null);
  useEffect(() => {
    if (salesEnergyCommission?.stationId) {
      ChargeHelper.API.getChargeStationDetail(salesEnergyCommission?.stationId).then((station) => {
        setSelectedChargeStation({
          id: station?.stationId,
          stationCode: station?.stationCode,
          name: station?.name,
          item: station,
          address: ChargeHelper.Utils.getChargeStationFullAddress(station),
        });
      });
    }
  }, [salesEnergyCommission])

  // quybka
  const contractListView = useMemo(() => {
    return <AgencyContractListView agencyId={agencyId} isAddContractDone={isAddContractDone} onRefresh={() => getAgencyDetail(agencyId)} />;
  }, [agencyId, isAddContractDone]);
  const [filterMonth, setFilterMonth] = useState('');
  const saleOrderListView = useMemo(() => {
    return <AgencySaleOrderListView agencyId={agencyId} month={filterMonth} showFullUI={isAdminAgency} />;
  }, [agencyId, filterMonth, isAdminAgency]);

  const subAgencyView = useMemo(() => {
    return (
      <SubAgencyView
        agencyId={agencyId}
        subAgenciesList={subAgenciesList}
        subAgencyTotal={subAgencyTotal}
        filter={filterSubAgency}
        onFilterChanged={(filter) => {
          setFilterSubAgency({
            ...filterSubAgency,
            ...filter,
          });
        }}
        handleGetSubAgenciesList={handleGetSubAgenciesList}
      />
    );
  }, [agencyDetail, subAgenciesList, subAgencyTotal]);
  const transactionHistoryView = useMemo(() => {
    return (
      <TransactionHistoryView
        agencyRole='SALE'
        agencyDetail={agencyDetail}
        transactionList={transactionList}
        transactionTotal={transactionTotal}
        filter={filterTransaction}
        onFilterChanged={(filter) => {
          setFilterTransaction({
            ...filterTransaction,
            ...filter,
          });
        }}
      />
    );
  }, [agencyDetail, transactionList, transactionTotal]);
  const saleKPIListView = useMemo(() => {
    return (
      <SaleKPIListView
        agencyDetail={agencyDetail}
        saleKPIList={saleKPIList}
        saleKPITotal={saleKPITotal}
        filter={filterSaleKPI}
        getAgencyDetail={getAgencyDetail}
        onFilterChanged={(filter) => {
          setFilterSaleKPI({
            ...filterSaleKPI,
            ...filter,
          });
        }}
      />
    );
  }, [agencyDetail, saleKPIList, saleKPITotal]);

  const remainingAgenciesView = useMemo(() => {
    return (
      <RemainingAgenciesView
        agencyId={agencyId}
        remainingAgenciesList={remainingAgenciesList}
        remainingAgenciesTotal={remainingAgenciesTotal}
        filter={filterRemainingAgencies}
        onFilterChanged={(filter) => {
          setFilterRemainingAgencies({
            ...filterRemainingAgencies,
            ...filter,
          });
        }}
        handleGetRemainingAgenciesList={handleGetRemainingAgenciesList}
      />
    );
  }, [agencyDetail, remainingAgenciesList, remainingAgenciesTotal]);

  const bankAccountsView = useMemo(() => {
    return (
      <BankAccountsView
        agencyId={agencyId}
        agencyDetail={agencyDetail}
        banksList={agencyBankList}
        getAgencyBankList={handleGetAgencyBankList}
      />
    );
  }, [agencyId, agencyDetail, agencyBankList]);

  // COINVESTOR
  const [isCoinvestorEnergyCommissionOn, setIsCoinvestorEnergyCommissionOn] = useState(true);
  const [coinvestorEnergyCommission, setCoinvestorEnergyCommission] = useState();
  const [coinvestorSelectedChargeStation, setCoinvestorSelectedChargeStation] = useState(null);

  useEffect(() => {
    if (coinvestorEnergyCommission?.stationId) {
      ChargeHelper.API.getChargeStationDetail(coinvestorEnergyCommission?.stationId).then((station) => {
        setCoinvestorSelectedChargeStation({
          id: station?.stationId,
          stationCode: station?.stationCode,
          name: station?.name,
          item: station,
          address: ChargeHelper.Utils.getChargeStationFullAddress(station),
        });
      });
    }
  }, [coinvestorEnergyCommission])

  useEffect(() => {
    if (
      coinvestorEnergyCommission?.length ||
      (typeof coinvestorEnergyCommission === 'object' && Object.values(coinvestorEnergyCommission)?.length)
    ) {
      if (coinvestorEnergyCommission?.energyCommissionValue || coinvestorEnergyCommission?.energyCommissionDuration) {
        setIsCoinvestorEnergyCommissionOn(true);
      } else setIsCoinvestorEnergyCommissionOn(false);

    } else setIsCoinvestorEnergyCommissionOn(false);
  }, [coinvestorEnergyCommission]);

  // ---- methods ----

  useEffect(() => {
    getAgencyDetail(agencyId);
  }, [agencyId]);

  useScrollToTop();

  const handleSelectedTab = (newTab) => {
    if (selectedTab === newTab) return;
    if (newTab === 'Danh sách hợp đồng') {
      router.navigate('#contract-list');
    }
    if (newTab === 'Đại lý cấp dưới') {
      router.navigate('#sub-agencies');
    }
    if (newTab === 'Lịch sử bán hàng') {
      router.navigate('#order-history');
    }
    if (newTab === 'Lịch sử giao dịch') {
      router.navigate('#transaction-history');
    }
    if (newTab === 'NĐT và chủ mặt bằng') {
      router.navigate('#remaining-agencies');
    }
    if (newTab === 'Tài khoản ngân hàng') {
      router.navigate('#bank-accounts');
    }
    if (newTab === 'Danh sách KPI') {
      router.navigate('#kpi-list');
    }
    setSelectedTab(newTab);
  };

  const AgencyInfo = () => {
    return (
      <div
        className="row m-0 position-relative p-3 bg-white rounded-lg"
        style={{
          border: `1px solid ${AppColors.gray[300]}`,
          boxShadow: '0px 7px 8px -3px #0000000D',
        }}
      >
        <div className="d-flex px-0 align-items-start w-100">
          <div className="d-flex align-items-center w-95">
            <img
              className="rounded-circle"
              src={
                (() => {
                  const ownerUser = agencyDetail?.users?.find(
                    user => user?.email === agencyDetail?.email
                  );
                  return ownerUser?.avatar
                    ? Utils.getFullUrl(ownerUser.avatar)
                    : AppResource.icons.avatar.default;
                })()
              }
              style={{
                width: 44,
              }}
            />
            <div className="d-flex flex-column ml-3 w-100">
              <div className="d-flex align-items-start gap-2" style={{ overflow: 'hidden' }}>
                <span
                  // className="font-weight-bolder text-ellipsis-2-lines"
                  style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}
                >
                  {agencyDetail?.name}
                </span>

                <span className="min-w-100px pt-1">
                  <KTLabel
                    text={t(`agencyStatus_${agencyDetail?.status}`)}
                    isInline={true}
                    size={KTLabelSize.medium}
                    additionalClassName={`label-light-${DealerHelper.getAgencyStatusColor(
                      agencyDetail?.status
                    )}`}
                  />
                </span>
              </div>
              {!isAdminAgency && (
                <div className="d-flex align-items-center gap-2">
                  <div
                    style={{
                      color: AppColors.gray[700],
                      fontSize: Utils.returnFontSize(14),
                      fontWeight: 400,
                    }}
                  >
                    {t('Số dư ví:')}
                  </div>
                  <span
                    style={{
                      color: AppColors.gray[800],
                      fontSize: Utils.returnFontSize(13),
                      fontWeight: 600,
                    }}
                  >
                    {Utils.formatNumber(agencyDetail?.balance)} VNĐ
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="d-flex gap-3 justify-content-end ml-auto">
            <VITableRowDropDown
              toggleElement={
                <a
                  href="#"
                  className="btn btn-sm btn-clean btn-icon h-45px w-45px hover-opacity-60"
                  style={{ backgroundColor: AppColors.gray[200] }}
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <i
                    className="fa-solid fa-ellipsis"
                    style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                  />
                </a>
              }
              menuItem={[
                {
                  iconElement: <i className={`fa-regular fa-bolt`}></i>,
                  text: t('Kích hoạt tài khoản'),
                  click: () => {
                    DealerHelper.handleAcceptAgency(agencyDetail, () => {
                      getAgencyDetail(agencyId);
                    });
                  },
                  show: agencyDetail?.status === 'REGISTERED' && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: <i className="fa-regular fa-pen-to-square"></i>,
                  text: t('edit'),
                  click: () => {
                    BreadcrumbHelper.setBreadcrumPath(
                      `Chỉnh sửa đại lý`,
                      `${router?.pathname}/edit`
                    );
                    router.navigate('edit');
                  },
                  show: (!agencyDetail?.numberOfSignedContracts || isAdminRole) && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: <i className="fa-regular fa-plus-circle"></i>,
                  text: t('addOrder'),
                  click: () => {
                    if (
                      agencyDetail?.numberOfSignedContracts &&
                      agencyDetail?.numberOfSignedContracts > 0
                    ) {
                      BreadcrumbHelper.setBreadcrumPath(
                        t('Tạo đơn hàng'),
                        `${router?.pathname}/agency-add-order`
                      );
                      router.navigate(`${AppRoute.saleList}/add-order?sale=${agencyId}`);
                    } else {
                      DealerHelper.showDialogCreateContract(agencyDetail);
                    }
                  },
                  show:
                    agencyDetail?.status === 'NORMAL'
                    && !isSaleInfo
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: <i className="far fa-square"></i>,
                  text: t('stopWorking'),
                  click: () => {
                    DealerHelper.handleStopAgency(agencyDetail, () => {
                      getAgencyDetail(agencyId);
                    });
                  },
                  show:
                    agencyDetail?.status === 'NORMAL'
                    && !isSaleInfo
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: <i className="far fa-play"></i>,
                  text: t('unStopWorking'),
                  click: () => {
                    DealerHelper.handleActiveAgency(agencyDetail, () => {
                      getAgencyDetail(agencyId);
                    });
                  },
                  show:
                    agencyDetail?.status === 'SUSPENDED'
                    && !isSaleInfo
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: <i className="far fa-bullseye-arrow"></i>,
                  text: t('Thiết lập KPI tháng'),
                  click: () => {
                    DealerHelper.setMonthKPI(agencyDetail, () => {
                      getAgencyDetail(agencyDetail?.agencyId);
                    });
                  },
                  show:
                    agencyDetail?.status !== 'REGISTERED'
                    && !isSaleInfo
                    && !isAdminAgency
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: <i className="fa-regular fa-file-contract"></i>,
                  text: 'Tạo hợp đồng CTV',
                  click: () => {
                    AgencyHelper.UI.showDialogConfirmCreateContractWithAgency(
                      agencyDetail,
                      () => {
                        setAddContractDone(true);
                      }
                    );
                  },
                  show:
                    agencyDetail?.status !== 'REGISTERED' &&
                    isAdminRole &&
                    Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: (
                    <i
                      className={`fa-regular fa-lock`}
                      style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                    ></i>
                  ),
                  text: t('Đặt lại mật khẩu'),
                  click: () => {
                    DealerHelper.showDialogChangePassword(agencyDetail, () => {
                      getAgencyDetail(agencyDetail?.agencyId);
                    });
                  },
                  show: isAdminRole && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleUpdate.code),
                },
                {
                  iconElement: <i className={`fa-regular fa-trash-can`}></i>,
                  text: t('Xóa đại lý'),
                  click: () => {
                    DealerHelper.handleDeleteAgency(agencyDetail, () => {
                      router.navigate(-1);
                    });
                  },
                  show:
                    !agencyDetail?.numberOfSignedContracts
                    && !isAdminAgency
                    && !isSaleInfo
                    && Utils.checkPermission(permissionList, AppConstants.permissionCode.saleDelete.code),
                },
              ]}
              singleBtnBgColor={AppColors.gray[200]}
            />
          </div>
        </div>

        <div
          className="my-4"
          style={{
            borderTop: `1px dashed ${AppColors.gray[300]}`,
          }}
        />

        {/* thong tin Dai ly */}
        <div className="col-xl-12 col-lg-12 col-md-12 d-flex flex-column px-0 ">
          <div className=" d-flex flex-lg-row flex-column flex-wrap">
            <>
              <div className="col-xl-6 p-0 pr-xl-3 pl-0 pr-0 my-1 d-flex flex-column gap-3">
                {AgencyUIHelper.buildAccountInfoCard(agencyDetail, parentAgencyDetail, isAgencyIndividual, "SALE", isAdminAgency)}

                {!isAdminAgency && isAgencyIndividual && <>{AgencyUIHelper.buildEKYCInfoCard(agencyDetail, () => getAgencyDetail(agencyId))}</>}

                {isAgencyIndividual && !isAdminAgency && AgencyUIHelper.buildHsmAgreementCard(agencyDetail)}
              </div>

              <div className="col-xl-6 p-0 my-1 d-flex flex-column gap-3">
                {AgencyUIHelper.buildOtherInfoCard(agencyDetail, agencyParentArea, agencyArea, agencyBank, isAgencyIndividual, isAdminRole, isSaleInfo)}

                {AgencyUIHelper.buildDocumentInfoCard(agencyDetail, isAgencyIndividual)}

                {!isAgencyIndividual && !isAdminAgency && AgencyUIHelper.buildHsmAgreementCard(agencyDetail)}
              </div>
            </>
          </div>
        </div>
      </div>
    );
  };

  if (!isReady) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div className="w-100">
        {!isSaleInfo && BreadcrumbHelper.buildBreadcrumb([
          {
            title: isAdminRole ? `Danh sách đại lý` : 'Danh sách đại lý cấp dưới',
            onPress: () => {
              router.navigate(-1);
            },
          },
          { title: 'Chi tiết đại lý' },
        ])}
      </div>

      <div className={`m-4 ${!isSaleInfo ? 'mt-16' : ''}`}>
        {/* thong tin Dai ly */}
        <CustomCard
          showHeader={false}
          additionalClassName="rounded-lg overflow-hidden"
          bgTransparent={true}
          showBorder={false}
          body={
            <div className="d-xl-flex d-lg-flex">
              <div
                className={`${isAdminAgency ? 'col-12' : 'col-xl-9 col-12 col-lg-12'} p-0 h-100`}
                ref={agencyInfoRef}
              >
                {/* thong tin Dai ly */}
                <AgencyInfo />
              </div>

              {!isAdminAgency && (
                <KTScrollCard
                  className="col-xl-3 col-lg-12 col-md-12 m-0 pl-lg-4 pl-0 pr-0 mb-sm-5 mb-lg-0 mt-5 mt-lg-0"
                  containerHeight={`${agencyInfoRef.current?.offsetHeight}px`}
                >
                  <BuildInfoCardView
                    type="progress"
                    bgIconColor="#51C86F"
                    icon={<i className="fas fa-bullseye-pointer fa-2x text-white" />}
                    name={`KPI tháng ${moment().format('MM/YYYY')}`}
                    additionalInfo={{
                      text: "Với đơn hàng nhượng quyền, liên kết và bán trụ sạc: Doanh thu được tính dựa trên giá trị sản phẩm trụ sạc đã bán trước thuế, không tính giá trị trang thiết bị & dịch vụ có trong đơn hàng.",
                      header: "KPI Tháng"
                    }}
                    contents={[
                      {
                        description: 'Tiến độ KPI tổng',
                        completed:
                          monthSaleKPI?.kpiValue || monthCoinvestorKPI?.kpiValue || monthPackageKPI?.kpiValue || monthChargePointKPI?.kpiValue
                            ? Math.round(
                              (((monthSaleKPI?.actualValue ?? 0) + (monthCoinvestorKPI?.actualValue ?? 0) + (monthPackageKPI?.actualValue ?? 0) + (monthChargePointKPI?.actualValue ?? 0)) /
                                ((monthSaleKPI?.kpiValue ?? 0) + (monthCoinvestorKPI?.kpiValue ?? 0) + (monthPackageKPI?.kpiValue ?? 0) + (monthChargePointKPI?.kpiValue ?? 0))) *
                              100
                            )
                            : 0,
                        value: (monthSaleKPI?.actualValue ?? 0) + (monthCoinvestorKPI?.actualValue ?? 0) + (monthPackageKPI?.actualValue ?? 0) + (monthChargePointKPI?.actualValue ?? 0),
                        maxValue: (monthSaleKPI?.kpiValue ?? 0) + (monthCoinvestorKPI?.kpiValue ?? 0) + (monthPackageKPI?.kpiValue ?? 0) + (monthChargePointKPI?.kpiValue ?? 0),
                        bgColor: '#30BD6F',
                      },
                      {
                        description: 'KPI Gói đầu tư HTKD',
                        completed: Math.round(monthPackageKPI?.kpiValue ? (monthPackageKPI?.actualValue / monthPackageKPI?.kpiValue) * 100 ?? 0 : 0),
                        value: monthPackageKPI?.actualValue ?? 0,
                        maxValue: monthPackageKPI?.kpiValue ?? 0,
                        bgColor: '#9385F2',
                      },
                      {
                        description: 'KPI Nhượng quyền',
                        completed: Math.round(monthSaleKPI?.kpiValue ? (monthSaleKPI?.actualValue / monthSaleKPI?.kpiValue) * 100 ?? 0 : 0),
                        value: monthSaleKPI?.actualValue ?? 0,
                        maxValue: monthSaleKPI?.kpiValue ?? 0,
                        bgColor: '#32ADE6',
                      },
                      {
                        description: 'KPI Bán liên kết',
                        completed: Math.round(monthCoinvestorKPI?.kpiValue ? (monthCoinvestorKPI?.actualValue / monthCoinvestorKPI?.kpiValue) * 100 ?? 0 : 0),
                        value: monthCoinvestorKPI?.actualValue ?? 0,
                        maxValue: monthCoinvestorKPI?.kpiValue ?? 0,
                        bgColor: '#DD4B92',
                      },
                      {
                        description: 'KPI Bán trụ sạc',
                        completed: Math.round(monthChargePointKPI?.kpiValue ? (monthChargePointKPI?.actualValue / monthChargePointKPI?.kpiValue) * 100 ?? 0 : 0),
                        value: monthChargePointKPI?.actualValue ?? 0,
                        maxValue: monthChargePointKPI?.kpiValue ?? 0,
                        bgColor: '#42D1B5',
                      },
                    ]}
                    additionalClassName="mb-4"
                    isHidden={true}
                    additionalButton={(
                      <div>
                        {UIHelper.buildNegativeButton('Đơn hàng liên quan', () => {
                          if (isAdminRole) {
                            setFilterMonth(moment().format('YYYY-MM'));
                            handleSelectedTab('Lịch sử bán hàng')
                          } else {
                            Utils.openInNewTab(`${AppRoute.agencyOrderList}`)
                          }
                        })}
                      </div>
                    )}
                  />

                  <BuildInfoCardView
                    type="table"
                    commissionType="package"
                    bgIconColor="#8676FF"
                    icon={<i className="fas fa-chart-user fa-2x text-white" />}
                    name="Bán gói đầu tư HTKD"
                    defaultText="Mức hoa hồng mặc định"
                    defaultValue={
                      commission?.packageCommission?.length &&
                      `${Math.round(commission?.packageCommission[0]?.discount * 100)}%`
                    }
                    textHeader={['Doanh thu đạt mức', 'Thưởng thêm']}
                    contents={
                      commission?.packageCommission?.length &&
                      DealerHelper.handleReformatCommission(commission?.packageCommission)?.slice(1)
                    }
                    additionalClassName="mb-4"
                  />

                  <BuildInfoCardView
                    type="table"
                    commissionType="sale"
                    bgIconColor="#4CADE3"
                    icon={<i className="fas fa-chart-line-up fa-2x text-white" />}
                    name="Bán nhượng quyền"
                    defaultText="Mức hoa hồng mặc định"
                    defaultValue={
                      commission?.saleCommission?.length &&
                      `${Math.round(commission?.saleCommission[0]?.discount * 100)}%`
                    }
                    textHeader={['Doanh thu đạt mức', 'Thưởng thêm']}
                    contents={
                      commission?.saleCommission?.length &&
                      DealerHelper.handleReformatCommission(commission?.saleCommission)?.slice(1)
                    }
                    additionalClassName="mb-4"
                  />

                  <BuildInfoCardView
                    type="table"
                    commissionType="sale"
                    bgIconColor="#DD4B92"
                    icon={<i className="fas fa-chart-network fa-2x text-white" />}
                    name="Bán liên kết"
                    defaultText="Mức hoa hồng mặc định"
                    defaultValue={
                      commission?.coinvestorCommission?.length &&
                      `${Math.round(commission?.coinvestorCommission[0]?.discount * 100)}%`
                    }
                    textHeader={['Doanh thu đạt mức', 'Thưởng thêm']}
                    contents={
                      commission?.coinvestorCommission?.length &&
                      DealerHelper.handleReformatCommission(commission?.coinvestorCommission)?.slice(1)
                    }
                    additionalClassName="mb-4"
                  />

                  <BuildInfoCardView
                    type="table"
                    commissionType="chargepoint"
                    bgIconColor="#42D1B5"
                    icon={<i className="fas fa-charging-station fa-2x text-white" />}
                    name="Bán trụ sạc"
                    defaultText="Mức hoa hồng mặc định"
                    defaultValue={
                      commission?.chargePointCommission?.length &&
                      `${Math.round(commission?.chargePointCommission[0]?.discount * 100)}%`
                    }
                    textHeader={['Doanh thu đạt mức', 'Thưởng thêm']}
                    contents={
                      commission?.chargePointCommission?.length &&
                      DealerHelper.handleReformatCommission(commission?.chargePointCommission)?.slice(1)
                    }
                    additionalClassName="mb-4"
                  />

                  {/* {isLandlordCommissionOn && Array.isArray(commission?.landlordCommission) && (
                    <BuildInfoCardView
                      type="table"
                      commissionType="landlord"
                      bgIconColor="#F8A51E"
                      icon={<i className="fas fa-house-chimney-user fa-2x text-white" />}
                      name="Giới thiệu mặt bằng"
                      defaultText="Mức hoa hồng áp dụng cho mỗi loại mặt bằng"
                      textHeader={['Loại mặt bằng', 'Mức hoa hồng']}
                      contents={commission?.landlordCommission}
                      additionalClassName="mb-4"
                    />
                  )} */}

                  {isLandlordCommissionOn && (
                    <BuildInfoCardView
                      type="table"
                      bgIconColor="#F8A51E"
                      icon={<i className="fas fa-house-chimney-user fa-2x text-white" />}
                      name="Giới thiệu mặt bằng"
                      defaultText="Mức hoa hồng áp dụng cho mỗi loại mặt bằng"
                      textHeader={['Mã mặt bằng', 'Cách tính']}
                      contents={premiseList?.map(premise => ({
                        name: `<div 
                            style="font-weight: 600; color: #30BD6F; cursor: pointer;" 
                            onclick="window.open('${AppRoute.premisesList}/${premise?.premiseId || 'Không xác định'}', '_blank')"
                          >${premise?.premiseId}</div>`,
                        value: `<div 
                            style="font-weight: 500; color: #494968; cursor: pointer;" 
                          >${handleGetLandlordCommissionType(premise)}</div>`
                      }))}
                      additionalButton={(
                        <div>
                          {UIHelper.buildNegativeButton('Xem danh sách mặt bằng', () => {
                            Utils.openInNewTab(`${AppRoute.premisesList}`)
                          })}
                        </div>
                      )}
                      additionalClassName="mb-4"
                    />
                  )}

                  {isEnergyCommissionOn
                    //  && Array.isArray(commission?.landlordCommission) 
                    && (
                      <BuildInfoCardView
                        bgIconColor="#00C7BE"
                        icon={<i className="fas fa-bolt fa-2x text-white" />}
                        name="Hoa hồng tiền điện NQ"
                        contents={[
                          {
                            value: salesEnergyCommission?.energyCommissionMode
                              ? t(`energyCommissionMode_${salesEnergyCommission?.energyCommissionMode}`)
                              : '',
                            description: 'Mô hình chia sẻ doanh thu',
                          },
                          {
                            value:
                              salesEnergyCommission?.energyCommissionValue != null
                                ? Utils.formatNumber(
                                  DealerHelper.reformatCommissionMode(
                                    salesEnergyCommission?.energyCommissionMode,
                                    salesEnergyCommission?.energyCommissionValue
                                  )
                                ) + ` ${commissionUnit}`
                                : '',
                            description: 'Mức hoa hồng mặc định',
                          },
                          {
                            value:
                              salesEnergyCommission?.energyCommissionDuration == null ||
                                salesEnergyCommission?.energyCommissionDuration == 0
                                ? 'Không thời hạn'
                                : salesEnergyCommission?.energyCommissionDuration + ' tháng',
                            description: 'Thời gian áp dụng',
                          },
                          {
                            value:
                              selectedChargeStation?.name ?? '',
                            description: 'Trạm sạc áp dụng',
                          },
                        ]}
                        additionalClassName="mb-4"
                      />
                    )}

                  {isCoinvestorEnergyCommissionOn && (
                    <BuildInfoCardView
                      bgIconColor="#4287D1"
                      icon={AppResource.icons.evg.icCoinvestorEnergy}
                      name="Hoa hồng tiền điện liên kết"
                      contents={[
                        {
                          value: coinvestorEnergyCommission?.energyCommissionMode
                            ? t(`energyCommissionMode_${coinvestorEnergyCommission?.energyCommissionMode}`)
                            : '',
                          description: 'Mô hình chia sẻ doanh thu',
                        },
                        {
                          value:
                            coinvestorEnergyCommission?.energyCommissionValue != null
                              ? Utils.formatNumber(
                                DealerHelper.reformatCommissionMode(
                                  coinvestorEnergyCommission?.energyCommissionMode,
                                  coinvestorEnergyCommission?.energyCommissionValue
                                )
                              ) + ` ${commissionUnit}`
                              : '',
                          description: 'Mức hoa hồng mặc định',
                        },
                        {
                          value:
                            coinvestorEnergyCommission?.energyCommissionDuration == null ||
                              coinvestorEnergyCommission?.energyCommissionDuration == 0
                              ? 'Không thời hạn'
                              : coinvestorEnergyCommission?.energyCommissionDuration + ' tháng',
                          description: 'Thời gian áp dụng',
                        },
                        {
                          value:
                            coinvestorSelectedChargeStation?.name ?? '',
                          description: 'Trạm sạc áp dụng',
                        },
                      ]}
                    />
                  )}
                </KTScrollCard>
              )}
            </div>
          }
        />

        {/* table */}
        <div className={isAdminAgency ? 'mt-4' : ''}>
          {tabs?.length > 1 && (
            <AppTabs
              tabs={tabs}
              activeTab={selectedTab}
              handleClick={handleSelectedTab}
              className="mt-2 mr-3"
              additionalClassName=""
            />
          )}
          <div
            className="bg-white shadow"
            style={{
              borderLeft: `1px solid ${AppColors.gray[300]}`,
              borderRight: `1px solid ${AppColors.gray[300]}`,
              borderBottom: `1px solid ${AppColors.gray[300]}`,
              borderRadius: tabs?.length > 1 ? '0px 10px 10px 10px' : '10px',
            }}
          >
            <AnimatePresence mode="wait">
              <motion.div
                key={selectedTab}
                initial={{ y: 10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -10, opacity: 0 }}
                transition={{ duration: 0.2 }}
              >
                {selectedTab == t('Danh sách hợp đồng') && (
                  <div className="py-4">{contractListView}</div>
                )}
                {selectedTab == 'Đại lý cấp dưới' && (
                  <div className="px-5 pb-3 pt-4">{subAgencyView}</div>
                )}
                {selectedTab == 'Lịch sử bán hàng' && (
                  <div className={!isAdminAgency ? 'px-1 pt-2' : ''}>{saleOrderListView}</div>
                )}
                {selectedTab == 'Lịch sử giao dịch' && (
                  <div className="px-5 pb-3 pt-4">{transactionHistoryView}</div>
                )}
                {selectedTab == 'NĐT và chủ mặt bằng' && (
                  <div className="px-5 pb-3 pt-4">{remainingAgenciesView}</div>
                )}
                {selectedTab == 'Tài khoản ngân hàng' && <div>{bankAccountsView}</div>}
                {selectedTab == 'Danh sách KPI' && (
                  <div className="px-5 pb-3 pt-4">{saleKPIListView}</div>
                )}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DealerDetailScreen;
